import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledAccessesCounterCard = styled.div(
    ({theme: {palette}}) => css`
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
        border-radius: 12px;
        border: 1px solid ${palette.neutral[200]};
        width: 100%;
        height: 100%;
    `
)

export const StyledAccessesCounterCardItem = styled(Flexbox)(
    ({theme}) => css`
        padding: ${theme.spacing * 4}px;
    `
)
